import { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { isObject, isEmpty, trim } from 'lodash';

import { KEYS } from 'components/utils/keys';
import { isValid as isFieldValid } from 'components/utils/form-utils';
import { ValidationErrorIndicator } from 'components/form/validationErrorIndicator';

import * as styled from './styles';

class TagsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      typed: '',
      focus: false,
    };
  }

  handleKeyUp(event) {
    const { shouldAddOnComma } = this.props;

    switch (event.keyCode) {
      case KEYS.ENTER:
        this.addItem();
        break;
      case KEYS.COMMA:
        if (shouldAddOnComma) {
          this.addItem();
        }
        break;
      default:
        break;
    }
  }

  handleKeyPress(event) {
    if (event.nativeEvent.keyCode === KEYS.ENTER) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  handleBlur() {
    const { shouldAddOnBlur } = this.props;

    this.setState({ focus: false });

    if (shouldAddOnBlur) {
      this.addItem();
    }
  }

  updateValue(event) {
    const { max, value } = this.props;

    if (value.length < max) {
      this.setState({ typed: event.target.value });
    }
  }

  addItem() {
    const { max, value, onChange, shouldAddOnComma } = this.props;
    const { typed } = this.state;
    const item = trim(typed, shouldAddOnComma ? ' ,' : ' ');

    if (value.length < max && !isEmpty(item) && !value.includes(item)) {
      this.setState({ typed: '' });
      onChange([...value, item]);
    }
  }

  removeItem(i) {
    const { value, onChange } = this.props;

    onChange(value.filter((_, index) => index !== i));
  }

  render() {
    const {
      intl,
      className,
      id,
      value,
      required,
      min,
      max,
      placeholder,
      isValid,
      shouldValidate,
    } = this.props;
    const { typed, focus } = this.state;

    const placeholderValue =
      (isObject(placeholder) && intl.formatMessage(placeholder)) ||
      placeholder ||
      '';
    const isInputValid = isValid
      ? isFieldValid({
          inputValue: value,
          inputType: 'tags',
          shouldValidate,
          required,
          min,
          max,
        })
      : isValid;

    return (
      <styled.InputContainer
        className={className}
        isValid={isInputValid}
        focus={focus}
      >
        {shouldValidate && !isInputValid && <ValidationErrorIndicator />}

        <styled.TagsList tags={value} onRemove={(i) => this.removeItem(i)} />

        <styled.Input
          id={id}
          value={typed}
          placeholder={placeholderValue}
          onChange={(event) => this.updateValue(event)}
          onKeyUp={(event) => this.handleKeyUp(event)}
          onKeyPress={(event) => this.handleKeyPress(event)}
          onFocus={() => this.setState({ focus: true })}
          onBlur={() => this.handleBlur()}
        />
      </styled.InputContainer>
    );
  }
}

TagsComponent.propTypes = {
  intl: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.array,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  required: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  isValid: PropTypes.bool,
  shouldValidate: PropTypes.bool,
  shouldAddOnComma: PropTypes.bool,
  shouldAddOnBlur: PropTypes.bool,
  onChange: PropTypes.func,
};

TagsComponent.defaultProps = {
  value: [],
  isValid: true,
  shouldAddOnComma: true,
  shouldAddOnBlur: false,
};

export const Tags = injectIntl(TagsComponent);
